import { render, staticRenderFns } from "./DataSearch.vue?vue&type=template&id=16d3844d&scoped=true"
import script from "./DataSearch.vue?vue&type=script&lang=js"
export * from "./DataSearch.vue?vue&type=script&lang=js"
import style0 from "./DataSearch.vue?vue&type=style&index=0&id=16d3844d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d3844d",
  null
  
)

export default component.exports